import { css } from "@emotion/css"

import Spacer from "@p-ban/common/src/components/layout/Spacer"

import ErrorText from "../ui/ErrorText/ErrorText"

type Props = {
  children: string | readonly string[] | undefined
  paddingTop?: number
  alignCenter?: boolean
}

const MyPageErrorMessages = ({ children = [], paddingTop = 0, alignCenter = false }: Props) => {
  const messages = (Array.isArray(children) ? children : [children]).filter((v) => !!v)

  if (messages.length === 0) {
    return null
  }

  const containerClassName = alignCenter ? styles.alignCenter : undefined
  const multi = messages.length >= 2

  return (
    <div className={containerClassName}>
      {paddingTop !== 0 && <Spacer size={paddingTop} />}
      {messages.map((message, i) => (
        <ErrorText key={i} multi={multi}>
          {message}
        </ErrorText>
      ))}
    </div>
  )
}

const styles = {
  alignCenter: css`
    text-align: center;
  `,
}

export default MyPageErrorMessages
